// extracted by mini-css-extract-plugin
export var option = "_82-0";
export var optionCard = "_82-f";
export var optionContent = "_82-g";
export var optionIcon = "_82-i";
export var optionIconBox = "_82-h";
export var optionLabel = "_82-j";
export var optionPill = "_82-m";
export var optionPillBadge = "_82-p";
export var optionPillIcon = "_82-n";
export var optionPillLabel = "_82-o";
export var optionRadio = "_82-k";
export var optionRadioInner = "_82-l";
export var optionReveal = "_82-2";
export var optionRevealDelay0 = "_82-3";
export var optionRevealDelay1 = "_82-4";
export var optionRevealDelay10 = "_82-d";
export var optionRevealDelay11 = "_82-e";
export var optionRevealDelay2 = "_82-5";
export var optionRevealDelay3 = "_82-6";
export var optionRevealDelay4 = "_82-7";
export var optionRevealDelay5 = "_82-8";
export var optionRevealDelay6 = "_82-9";
export var optionRevealDelay7 = "_82-a";
export var optionRevealDelay8 = "_82-b";
export var optionRevealDelay9 = "_82-c";
export var optionSelected = "_82-1";